import {getQueryFilter} from 'utils/helper'
import {DESK_TASK} from './endpoint'
import {
  CREATE_TASK,
  GET_ALL_TASK,
  GET_TASK,
  DELETE_TASK,
  EDIT_TASK,
  GET_TASK_OF_CONTACT,
  CREATE_SUBTASK,
  EDIT_SUBTASK,
  DELETE_SUBTASK,
  CREATE_TASK_NOTE,
} from './types'
import {apiAction} from './api'

export function createTaskActivities(data) {
  return apiAction({
    url: DESK_TASK,
    method: 'POST',
    label: CREATE_TASK,
    data,
    showToast: true,
    successMessage: 'Task Created',
  })
}

export function createSubtask(data) {
  return apiAction({
    url: `${DESK_TASK}/subtasks`,
    method: 'POST',
    label: CREATE_SUBTASK,
    data,
    showToast: true,
    successMessage: 'Subtask Created',
  })
}

export function getAllTaskActivities(params) {
  const query = getQueryFilter(params || {})

  const url = `${DESK_TASK}?${query}`

  return apiAction({
    url,
    method: 'GET',
    label: GET_ALL_TASK,
  })
}

export function getTaskActivities(id) {
  return apiAction({
    url: `${DESK_TASK}/${id}`,
    method: 'GET',
    label: GET_TASK,
  })
}

export function deleteTaskActivities(id) {
  return apiAction({
    url: `${DESK_TASK}/${id}`,
    method: 'DELETE',
    label: DELETE_TASK,
    showToast: true,
    successMessage: 'Task deleted',
  })
}

export function deleteSubtask(id) {
  return apiAction({
    url: `${DESK_TASK}/subtasks/${id}`,
    method: 'DELETE',
    label: DELETE_SUBTASK,
    showToast: true,
    successMessage: 'Subtask deleted',
  })
}

export function editTaskActivities(id, data) {
  return apiAction({
    url: `${DESK_TASK}/${id}`,
    method: 'PUT',
    label: EDIT_TASK,
    data,
    showToast: true,
    successMessage: 'Task Updated',
  })
}

export function editSubtask(id, data) {
  return apiAction({
    url: `${DESK_TASK}/subtasks/${id}`,
    method: 'PUT',
    label: EDIT_SUBTASK,
    data,
    showToast: true,
    successMessage: 'Subtask Updated',
  })
}

export function getActivitiesOfContact(id) {
  return apiAction({
    url: `${DESK_TASK}/contacts/${id}`,
    method: 'GET',
    label: GET_TASK_OF_CONTACT,
  })
}

export function createTaskNote(id, data) {
  return apiAction({
    url: `${DESK_TASK}/${id}/note`,
    method: 'POST',
    label: CREATE_TASK_NOTE,
    data,
    showToast: true,
    successMessage: 'Note Added',
  })
}
